/**
 * Prüft, ob die Seite im Preview-Modus ist (per URL-Parameter ?preview=true)
 */
export function isPreviewMode(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("preview") === "true";
}

/**
 * Hängt ?preview=true an eine URL an, wenn gerade Preview aktiv ist
 */
export function appendPreviewParam(url: string): string {
    if (isPreviewMode()) {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}preview=true`;
    }
    return url;
}
